export const DeviceOrderStatus = {
    New: 'new',
    Success: 'success',
    Failed: 'failed',
};
export const DeviceOrderPaymentStatus = {
    New: 'new',
    Waiting: 'waiting',
    Success: 'success',
    Failed: 'failed',
};
export const DeviceOrderShippingStatus = {
    Preparing: 'preparing',
    Shipping: 'shipping',
    Failed: 'failed',
    Success: 'success',
};
export const TrialDays = 10;
//# sourceMappingURL=deviceOrder.js.map